import {useEffect} from 'react';
import {useForm, useFormState} from 'react-final-form';
import QueryStorage from "../../../../common/helpers/QueryStorage";

export default function useSyncedField(fieldName, type = 'int') {
    const {values} = useFormState();
    const {change} = useForm();

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const base = fieldName.toLowerCase();
        let paramValue =
            params.get(fieldName) ||
            params.get(base) ||
            params.get(base + 'num') ||
            params.get(base + 'Num') ||
            QueryStorage.get(fieldName);

        if (
            paramValue !== null &&
            paramValue !== undefined &&
            paramValue !== 'null' &&
            paramValue !== 'undefined' &&
            paramValue !== 'false'
        ) {
            let parsedValue = paramValue;

            if (type === 'int') {
                if (
                    typeof paramValue === 'string' &&
                    /^-?\d+$/.test(paramValue.trim())
                ) {
                    parsedValue = parseInt(paramValue, 10);
                    change(fieldName, parsedValue);
                    QueryStorage.set(fieldName, parsedValue);
                }
            } else if (type === 'float') {
                if (
                    typeof paramValue === 'string' &&
                    /^-?\d+(\.\d+)?$/.test(paramValue.trim())
                ) {
                    parsedValue = parseFloat(paramValue);
                    change(fieldName, parsedValue);
                    QueryStorage.set(fieldName, parsedValue);
                }
            } else {
                change(fieldName, parsedValue);
                QueryStorage.set(fieldName, parsedValue);
            }
        }
    }, [change, fieldName, type]);

    useEffect(() => {
        let currentValue = values[fieldName];
        if (
            currentValue !== null &&
            currentValue !== undefined &&
            currentValue !== 'null' &&
            currentValue !== 'undefined' &&
            currentValue !== 'false'
        ) {
            QueryStorage.set(fieldName, currentValue);
        }
    }, [values[fieldName], fieldName]);
}
